import React, { useContext, useState } from "react";

import Header from "../../components/Header";
import { Context as PermissoesContext } from "../../Context/PermissoesContext";

import Abas from "./Componentes/Abas";
import { IntervaloDataContextProvider } from "./Context/IntevervaloDataContext";
import { NotasFiscaisContextProvider } from "./Context/NotasFiscaisContext";
import { SincronizacaoFaturamentoContextProvider } from "./Context/SincronizacaoFaturamentoContext";
import Lotes from "./Lotes";
import NaoLoteados from "./NaoLoteados";
import NotasFiscais from "./NotasFiscais";
import Recebimento from "./Recebimento";
import { ModalRecebimentoContextProvider } from "./Recebimento/Context/ModalRecebimentoContext";
import { RecebimentoContextProvider } from "./Recebimento/Context/RecebimentoContext";

import "./styles.css";

const TABS = [
  {
    id: 7,
    label: "Lotes",
    permission: "FAT003",
    component: <Lotes />,
  },
  {
    id: 4,
    label: "Recebimento",
    permission: "FAT004",
    component: <Recebimento />,
  },
  {
    id: 5,
    label: "Não Loteado",
    permission: "FAT005",
    component: <NaoLoteados />,
  },
  {
    id: 6,
    label: "Notas Fiscais",
    permission: "FAT013",
    component: <NotasFiscais />,
  },
];

export default function Faturamento() {
  const { checarPermissaoComAcao } = useContext(PermissoesContext);
  const [tab, setTab] = useState(7);

  const handleTabChange = (tabId) => {
    const selectedTab = TABS.find((item) => item.id === tabId);

    if (!selectedTab) {
      return;
    }

    checarPermissaoComAcao(selectedTab.permission, () => setTab(tabId));
  };

  const activeTab = TABS.find((item) => item.id === tab);

  return (
    <>
      <Header titulo="Faturamento" />
      <IntervaloDataContextProvider>
        <SincronizacaoFaturamentoContextProvider>
          <ModalRecebimentoContextProvider>
            <RecebimentoContextProvider ativo={tab === 4}>
              <NotasFiscaisContextProvider ativo={tab === 6}>
                <div className="container-central-faturamento">
                  <main className="container-abas-faturamento">
                    <Abas
                      tabs={TABS}
                      value={tab}
                      handleChange={handleTabChange}
                    />
                  </main>
                  {activeTab?.component}
                </div>
              </NotasFiscaisContextProvider>
            </RecebimentoContextProvider>
          </ModalRecebimentoContextProvider>
        </SincronizacaoFaturamentoContextProvider>
      </IntervaloDataContextProvider>
    </>
  );
}
